import { Image } from "@/components/Image/Image";
import type { RoomImage } from "@/features/hotels/types/types";

type Props = {
  onClick: () => void;
  thumbnailImage: RoomImage;
  imageCount: number;
};

export const RoomGalleryButton = ({
  onClick,
  thumbnailImage,
  imageCount,
}: Props) => {
  return (
    <button
      type="button"
      className="relative h-30 w-22.5 shrink-0 overflow-clip rounded-2xl"
      onClick={onClick}
    >
      <Image
        className="h-full w-full object-cover"
        src={thumbnailImage.url}
        alt={thumbnailImage.name}
      />

      <div className="absolute bottom-0 left-0 z-1 bg-black ps-2 pe-1">
        <div className="flex items-center justify-center gap-0.5">
          <div className="text-xs text-white">{imageCount}+</div>
          <Image src={"/image.svg"} width={9} height={9} alt="image" />
        </div>
      </div>
    </button>
  );
};
